export default __webpack_public_path__ + "static/media/itqan.15772851.png";